// extracted by mini-css-extract-plugin
module.exports = {"eventContainer":"events_eventContainer__2en2C","results":"events_results__3JCTe","cards":"events_cards__2cpca"};